import { Route, Switch } from 'react-router';
import { FieldManagerSurvey } from '../../surveys/FieldsSurveys/FieldManagerSurvey';
import {
  FieldManagerDataProvider,
  useFieldManagerDataContext,
} from '../hooks/FieldManagerDataContext';
import {
  createFieldRoute,
  fieldDetailRoute,
  fieldManagerPath,
} from '../routes';
import { CreateFieldForm } from './create-field/CreateFieldForm';
import { FieldDetail } from './field-detail/FieldDetail';
import { Overview } from './overview/Overview';

const FieldManagerRoutesContent = () => {
  const { isLoading } = useFieldManagerDataContext();

  return (
    <>
      <Switch>
        <Route exact path={fieldDetailRoute()}>
          <FieldDetail />
        </Route>
        <Route exact path={createFieldRoute()}>
          <CreateFieldForm />
        </Route>
        <Route exact path={fieldManagerPath()}>
          <Overview />
        </Route>
      </Switch>
      <FieldManagerSurvey allDataLoaded={!isLoading} />
    </>
  );
};

export const FieldManagerRoutes = () => (
  <FieldManagerDataProvider>
    <FieldManagerRoutesContent />
  </FieldManagerDataProvider>
);
